import React, { useEffect, useState } from 'react';
import Button from "../../components/ripple/Button";
import styles from './NavGroup.module.scss'
import { withRouter } from "next/router";
import FoldingContent from "../../components/folding/FoldingContent";
import Link from "next/link";

import { NAV_EXPLAINS } from "../../settings/navigation";

function NavGroup({group, article}) {

    const [folded, setFolded] = useState(true);

    useEffect(() => {
        if (!!group.docs.find(a => a._id === article._id)) setFolded(false);
    }, []);

    if (!group.docs.length) return null;

    return (
        <div className={`${styles.nav}`} data-explain-group-folded={folded}>
            {
                group.docs.some(d => d._id === article._id)
                ?
                    <div className={styles.nav__title}>
                        <p className={styles.nav__title__text}>{group.title || 'Undefined title'}</p>
                    </div>
                    :
                    <Button
                        className={styles.nav__head}
                        onClick={() => setFolded(!folded)}
                        title={group.title || 'Undefined title'}
                        iconRight={`fas fa-chevron-up`}
                        displayType='text'
                        visuals={{colorBasic: [`var(--colorFontTitle)`]}}
                    />
            }
            <FoldingContent folded={folded}>
                <ul className={styles.nav__list}>
                    {
                        group.docs.map((doc, index) => (
                            <li
                                className={styles.nav__list__doc}
                                data-explain-doc-selected={doc._id === article._id}
                                key={index}
                            >
                                <Link
                                    href={`${NAV_EXPLAINS}/${doc.slug}`}
                                    className={styles.nav__list__doc__link}>

                                    <Button
                                        className={`${styles.nav__list__doc__link__button}`}
                                        displayType='text'
                                        title={doc.title || 'Untitled'}
                                        visuals={{
                                            colorBasic: doc._id === article._id
                                                ? [`var(--colorAccentBasic)`]
                                                : [`var(--colorFontTitle)`]
                                        }}
                                        tabIndex='-1'
                                    />

                                </Link>
                            </li>
                        ))
                    }
                </ul>
            </FoldingContent>
        </div>
    );
}

export default withRouter(NavGroup)